export default __webpack_public_path__ + "static/media/84.39984c47.jpg";